import { api } from "./client";

/**
 * Phase 5.4 — Comparatives API client.
 *
 * - list: GET /api/comparatives → { items: [...] }
 * - get:  GET /api/comparatives/:id → comparative
 * - create: POST /api/comparatives
 * - update: PATCH /api/comparatives/:id
 * - remove: DELETE /api/comparatives/:id
 * - toggleStar: POST /api/comparatives/:id/star
 * - run: POST /api/comparatives/run (preview, sin guardar)
 * - runSaved: POST /api/comparatives/:id/run
 */
export const comparatives = {
  list: () => api.get("/comparatives"),
  get: (id) => api.get(`/comparatives/${id}`),
  create: (body) => api.post("/comparatives", body),
  update: (id, body) => api.patch(`/comparatives/${id}`, body),
  remove: (id) => api.delete(`/comparatives/${id}`),
  toggleStar: (id) => api.post(`/comparatives/${id}/star`),
  run: (config) => api.post("/comparatives/run", { config }),
  runSaved: (id) => api.post(`/comparatives/${id}/run`),
  // Phase 5.6 — share token CRUD
  share: (id) => api.post(`/comparatives/${id}/share`),
  revokeShare: (id) => api.delete(`/comparatives/${id}/share`),
};

export default comparatives;
